import React, { useEffect, useRef, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link, useLocation } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Loader from "../../../core/common/selfLoder";
import useApi from "../../../core/customhook/useApi";
import OrgChart from "./organization_stracture/OrgChart";
import FunChart from "./functional/FunChart";
declare global {
  interface Window {
    Highcharts: any;
  }
}

const OrganisationStructure = () => {
  const chartRef = useRef(null);
  const [orgdata, setOrgdata] = useState({ data: [], node: [] });
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState<"org" | "fun">("org");

  const {
    data: orgChartData,
    loading: orgChartLoading,
    error: orgChartError,
  } = useApi("/api/organizational-structure", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (orgChartData) {
      setOrgdata({
        data: orgChartData.data || [],
        node: orgChartData.nodes || [],
      });
    }
  }, [orgChartData]);

  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
      <Loader loading={orgChartLoading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Organization Structure</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Company Overview</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Organization Structure
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="org-wrapper">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="button-group text-center">
                    <button
                      className={`custom-btn mx-2 mb-2 md:mb-0 ${view === "org" ? "active-btn" : ""}`}
                      onClick={() => setView("org")}
                    >
                      Our Organization
                    </button>
                    &nbsp;
                    <button
                      className={`custom-btn mx-2 ${view === "fun" ? "active-btn" : ""}`}
                      onClick={() => setView("fun")}
                    >
                      Functional Structure
                    </button>
                  </div>
                </div>
              </div>
              {/* Conditional Component Rendering */}
              <div className="row">
                <div className="col-md-12">
                  {view === "org" ? (
                    <OrgChart />
                  ) : (
                    <FunChart />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className="footer d-flex align-items-center justify-content-center border-top bg-white p-3 fixed bottom-0 left-0 right-0 ">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default OrganisationStructure;

